import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './app/HomePage';
import DashboardPage from './app/dashboard/DashboardPage';
import CreateProjectPage from './app/dashboard/CreateProjectPage';
import ProjectDetailPage from './app/dashboard/ProjectDetailPage';
import PitchDeckPage from './app/PitchDeckPage';
import './styles/index.css';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "";

// Wrap app with GoogleOAuthProvider only if client ID is provided
const App = () => {
  const routes = (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/dashboard/projects/new" element={<CreateProjectPage />} />
        <Route path="/dashboard/projects/:id" element={<ProjectDetailPage />} />
        <Route path="/pitch" element={<PitchDeckPage />} />
      </Routes>
    </BrowserRouter>
  );

  if (GOOGLE_CLIENT_ID) {
    return (
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        {routes}
      </GoogleOAuthProvider>
    );
  }

  return routes;
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



